import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "footer"
};
const _hoisted_2 = {
  class: "footer-left"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("footer", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createTextVNode(" ©2021 - " + _toDisplayString($data.currentYear) + " By ", 1), _cache[0] || (_cache[0] = _createElementVNode("a", {
    href: "https://adil.com.cn",
    target: "_blank",
    rel: "noopener noreferrer",
    class: "adil-link"
  }, " Adil ", -1))]), _cache[1] || (_cache[1] = _createElementVNode("div", {
    class: "footer-right"
  }, [_createElementVNode("a", {
    href: "https://beian.miit.gov.cn",
    target: "_blank",
    rel: "noopener noreferrer",
    class: "beian-link"
  }, " 京ICP备20030919号-1 ")], -1))]);
}